import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_9: FaireProductEntity = {
  token: "atc_refined_moma_9",
  type: "product",
  name: "Vibrant Porcelain Mugs",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c76025fbc1e1403ed001eabae8ab4730ad28c63b53c015b3bfa89325d11d5e9b.webp",
  priceDollars: 36,
  msrpDollars: 60,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
